"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MeterNumberValidationHelpers = _interopRequireDefault(require("../../../../../utils/MeterNumberValidationHelpers"));
var REGEX_INFO_TOKEN_MATCH = /[^%%]+(?=%%)/g;
function replaceTokensInMostRelevantInfoMessage(template, infoMessage) {
  var resultTemplate = template;
  var tokenMatches = template.match(REGEX_INFO_TOKEN_MATCH);
  tokenMatches.forEach(function (tokenMatch) {
    var tokenWithBrackets = "%%".concat(tokenMatch, "%%");
    var tokenReplacement = infoMessage[tokenMatch];
    if (!tokenReplacement) return;
    if (tokenMatch === 'date') {
      tokenReplacement = tokenReplacement.reverse().join('.');
    }
    if (tokenMatch === 'meterSerialNumber') {
      tokenReplacement = _MeterNumberValidationHelpers.default.removeRedundantZeros(tokenReplacement);
    }
    resultTemplate = resultTemplate.replace(tokenWithBrackets, tokenReplacement);
  });
  return resultTemplate;
}
function getMeterReadingInfoMessageText() {
  var infoMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var meterReadingInfoMessages = arguments.length > 1 ? arguments[1] : undefined;
  var getMostRelevantReasonTextTemplate = function getMostRelevantReasonTextTemplate(reason) {
    var mostRelevantReasonText = meterReadingInfoMessages.find(function (info) {
      return info.reason === reason;
    }) || {};
    return mostRelevantReasonText.text;
  };
  if (infoMessages && infoMessages.length) {
    var mostRelevantInfoMessage = infoMessages[0];
    var mostRelevantReason = mostRelevantInfoMessage.reason;
    var mostRelevantReasonTextTemplate = getMostRelevantReasonTextTemplate(mostRelevantReason) || null;
    if (mostRelevantReasonTextTemplate) {
      return replaceTokensInMostRelevantInfoMessage(mostRelevantReasonTextTemplate, mostRelevantInfoMessage);
    }
  }
  return '';
}
var _default = exports.default = getMeterReadingInfoMessageText;